import { IProduct } from '../types/products'
import { isBelowMinimum } from './minimumQuantity'

export function useCartMinimums(cart: IProduct[]) {
  const hasMinimumErrors = cart.some(isBelowMinimum)
  return {
    checkedCart: cart,
    blocked: hasMinimumErrors,
    hasMinimumErrors,
  }
}
